import React, { useState } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "../../../Components/UI/Paper";
import Typography from "@mui/material/Typography";

import { useLoaderData, useNavigate } from "react-router-dom";
import { getBooks, createBook, getFileCategory } from "API/swesum";

import usePost from "Hooks/usePost";
import Button from "@mui/material/Button";

import { BooksForm } from "Components/books/BooksForm";
import { useAccountCharts } from "Context/AccountCharts";
import { LoadingButton } from "@mui/lab";
import { AccountChartForm } from "Components/AccountCharts/AccountChartForm";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const initialState = {
  Id: "",
  Title: "",
  Name: "",
  AccountNumber: "",
  VAT: 0,
};

export function CreateAccountChart() {
  const navigate = useNavigate();
  const { openError } = usePopupNotificationContext();
  const { createAccountChart, loading } = useAccountCharts();

  const [formData, setFormData] = useState(initialState);

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const submit = async () => {
    const res = await createAccountChart(formData);
    if (res.status === 201) {
      navigate(`/accountcharts/${res.data.Id}`);
    } else {
      openError(res.Message);
    }
  };
  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, pt: 8, pb: 3, pl: 3, pr: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography
                  sx={{ marginBottom: "1.0rem" }}
                  variant="h5"
                  align="left"
                >
                  Skapa kontoplan
                </Typography>
                <AccountChartForm
                  formData={formData}
                  handleInputChange={handleInputChange}
                />
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 1,
                  }}
                >
                  <Button onClick={() => navigate(-1)}>Stäng</Button>
                  <LoadingButton
                    loading={loading}
                    onClick={submit}
                    variant="contained"
                    sx={{ ml: 3 }}
                  >
                    Spara
                  </LoadingButton>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
